// Lightweight error reporter for the web build.
//
// Sentry is *optional*: if VITE_SENTRY_DSN is unset, we fall back to
// console-level error logging only. This keeps the dev build free of
// network calls and the bundle small for cost-conscious deploys.
//
// We don't add @sentry/browser as a dep — instead the install code
// dynamically imports it only when a DSN is present, so the cost
// shows up only when the user opts in.

let booted = false;

export async function installObservability() {
  if (booted) return;
  booted = true;

  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const env = import.meta.env.VITE_SCREENPLAY_ENV || import.meta.env.MODE || 'development';

  window.addEventListener('error', (ev) => {
    console.error('[lastslate-web] window.error', ev.error || ev.message);
  });
  window.addEventListener('unhandledrejection', (ev) => {
    console.error('[lastslate-web] unhandled rejection', ev.reason);
  });

  if (!dsn) return;

  // Dynamic import via a Function() so neither Vite nor Rollup
  // statically resolves @sentry/browser at bundle time. Adds zero
  // bytes to the main bundle; only fetches Sentry over the network
  // when a DSN is present at runtime AND the dep is installed.
  // To enable: `npm i @sentry/browser` and set VITE_SENTRY_DSN.
  try {
    const dynamicImport = new Function('m', 'return import(m)');
    const Sentry = await dynamicImport('@sentry/browser');
    Sentry.init({
      dsn,
      environment: env,
      tracesSampleRate: 0,
      release: import.meta.env.VITE_RELEASE_TAG || undefined,
    });
  } catch (err) {
    console.warn('[lastslate-web] Sentry not installed; npm i @sentry/browser to enable.', err);
  }
}
